export const AMPLITUDE_PROXY_URL = "https://event.amp.bounce.com/send"
